module.exports = __webpack_public_path__ + "02_glasses_brown.627ab65e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer4/02_glasses_brown.png
// module id = B9P8
// module chunks = 0